export { getStaticPathsFromStoryblokSlugGenerator } from './get-static-paths'
